export default __webpack_public_path__ + "static/media/CEM-Maths.913252d8.jpg";